/**
 * The community Discord invite from VITE_DISCORD_URL (set on the web build), or
 * null when it is unset or not an https link. Read on each call, so a test can
 * stub the env. The one reader of that variable, for every surface that shows
 * the invite: the site footer, the player's ending panel, the feedback form and
 * the closed-beta sign-in screen.
 */
export function discordInviteUrl(raw: unknown = import.meta.env.VITE_DISCORD_URL): string | null {
  const url = typeof raw === "string" ? raw.trim() : "";
  return /^https:\/\//.test(url) ? url : null;
}
